var cell_phone = {};
module['exports'] = cell_phone;
cell_phone.formats = require("./formats");